import { render } from "./VotingPhotosCard.vue?vue&type=template&id=10bf4a66&scoped=true"
import script from "./VotingPhotosCard.vue?vue&type=script&lang=js"
export * from "./VotingPhotosCard.vue?vue&type=script&lang=js"

import "./VotingPhotosCard.vue?vue&type=style&index=0&id=10bf4a66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-10bf4a66"

export default script